import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import WebsiteApiService from '../../ApiServices/WebsiteApiService/WebsiteApiService';
import AppApiService from '../../ApiServices/WebsiteApiService/AppApiService';
import { useAuth } from "../Auth/AuthContext";
import { CheckCircle, MoreVertical } from "lucide-react";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import 'react-toastify/dist/ReactToastify.css';

const WebsiteTable = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");
    const [rejectionFile, setRejectionFile] = useState(null);

    const [webData, setWebData] = useState([]); // Data for "Web"
    // For search in web
    const [webFilteredData, setWebFilteredData] = useState(webData);

    const [appData, setAppData] = useState([]); // Data for "App"
    // For search in app
    const [appFilteredData, setAppFilteredData] = useState(webData);


    const [activeTable, setActiveTable] = useState("Website"); // Default to "Web" table

    const [editType, setEditType] = useState(null); // "Website" or "App"
    const [currentEditItem, setCurrentEditItem] = useState(null); // Item being edited
    const Auth = useAuth();
    const user = Auth.authState.user;
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";

    const status = {
        GettingReady: "Getting Ready",
        Approved: "Approved",
        Disapproved: "Disapproved"
    }

    const webHeaders = [
        { label: "Company Name", selector: "CompanyName" },
        { label: "Publisher Name", selector: "PublisherName" },
        { label: "Name", icon: <CheckCircle size={16} />, selector: "Name" },
        { label: "URL", icon: <MoreVertical size={16} />, selector: "Url" },
        { label: "Status", icon: <MoreVertical size={16} />, selector: "Status" },
        { label: "Attachment", icon: <MoreVertical size={16} />, selector: "" },
        { label: "Actions", icon: <MoreVertical size={16} />, selector: "Actions" }
    ];
    const appHeaders = [
        { label: "App Id", selector: "AppId" },
        { label: "Company Name", selector: "CompanyName" },
        { label: "Publisher Name", selector: "PublisherName" },
        { label: "Name", icon: <CheckCircle size={16} />, selector: "Name" },
        { label: "URL", icon: <MoreVertical size={16} />, selector: "Url" },
        { label: "Status", icon: <MoreVertical size={16} />, selector: "Status" },
        { label: "Attachment", icon: <MoreVertical size={16} />, selector: "" },
        { label: "Actions", icon: <MoreVertical size={16} />, selector: "Actions" }
    ];
    const fetchData = async () => {
        try {
            const websiteData = admin === true ? await WebsiteApiService.Get() : await WebsiteApiService.GetAllWebByUserId(user.id);
            const appData = admin === true ? await AppApiService.Get() : await AppApiService.GetAllAppByUserId(user.id);

            const websiteDataArray = Array.isArray(websiteData.data) ? websiteData.data : [websiteData.data];
            const appDataArray = Array.isArray(appData.data) ? appData.data : [appData.data];

            const websiteDataWithStatus = websiteDataArray.map((item) => ({
                Name: item.Name || item.name,
                Title: item.Title || item.title,
                Url: item.Url || item.url,
                Description: item.Description || item.description,
                CreatedOn: new Date(item.CreatedOn || item.createdOn).toISOString().split('T')[0], //item.CreatedOn || item.createdOn,
                ApprovalStatus: item.readableStatus,
                status: 'Website',
                URL: item.url,
                CompanyName: item.companyName,
                PublisherName: item.publisherName,
                WebsiteId: item.WebsiteId || item.websiteId,
                IsAttachmentAvailable: item.isAttachmentAvailable
            }));

            const appDataWithStatus = appDataArray.map((item) => ({
                Name: item.Name || item.name,
                Title: item.Title || item.title,
                Url: item.Url || item.url,
                Description: item.Description || item.description,
                CreatedOn: new Date(item.CreatedOn || item.createdOn).toISOString().split('T')[0], //item.CreatedOn || item.createdOn,
                ApprovalStatus: item.readableStatus,
                status: 'App',
                CompanyName: item.companyName,
                PublisherName: item.publisherName,
                Id: item.Id || item.id,
                AppId: item.AppId || item.appId,
                IsAttachmentAvailable: item.isAttachmentAvailable
            }));
            setWebFilteredData(websiteDataWithStatus || []);
            setWebData(websiteDataWithStatus);

            setAppData(appDataWithStatus);
            setAppFilteredData(appDataWithStatus || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const changeWebsiteStatus = async (event, index) => {
        const newStatus = event.target.value;
        let seletedItem = webData.filter(x => x.WebsiteId == index)[0]
        setCurrentItem(seletedItem)
        let id = seletedItem.WebsiteId;

        if (newStatus == status.Disapproved) {
            event.preventDefault();
            setIsRejectionModalOpen(true)
            return;
        }
        const formData = new FormData();
        formData.append("status", newStatus);
        formData.append("id", id);
        toast.info("Please wait for a while to update status");
        // Call API to update status in the database
        await WebsiteApiService.ChangeStatus(formData);
        toast.success("Status updated");
        await fetchData();
    };
    const handleRejectionStatus = async () => {
        const formData = new FormData();
        formData.append("status", status.Disapproved);
        formData.append("rejectionReason", rejectionReason);

        if (rejectionFile) {
            formData.append("RejectionAttachment", rejectionFile);
        }

        if (activeTable == "Website") {
            formData.append("id", currentItem.WebsiteId);
            toast.info("Please wait for a while to update status");
            // Call API to update status in the database
            await WebsiteApiService.ChangeStatus(formData);
            toast.success("Web Rejected");
        } else {
            formData.append("id", currentItem.Id);

            // Call API to update status in the database
            await AppApiService.ChangeStatus(formData);
            toast.success("App Rejected");
        }
        setRejectionReason("");
        setIsRejectionModalOpen(false)
        await fetchData();
    }


    const changeAppStatus = async (event, index) => {
        const newStatus = event.target.value;

        let seletedItem = appData.filter(x => x.Id == index)[0];
        setCurrentItem(seletedItem)
        let id = seletedItem.Id;

        if (newStatus == status.Disapproved) {
            event.preventDefault();
            setIsRejectionModalOpen(true)
            return;
        }

        let model = {
            id: id,
            status: newStatus
        }
        // Call API to update status in the database
        await AppApiService.ChangeStatus(model);
        toast.success("Status updated");
        await fetchData();
    };

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        fetchData();
    }, []);

    const openEditModal = (type, item) => {
        setEditType(type);
        setCurrentEditItem(item);
        setIsEditing(true);
    };

    const DownloadWebRejectionAttachment = (id) => {
        WebsiteApiService.DownloadRejectionAttachment(id);
    }
    const DownloadAppRejectionAttachment = (id) => {
        AppApiService.DownloadRejectionAttachment(id);
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editType === "Website") {
                const websiteData = {
                    Name: currentEditItem.Name,
                    Url: currentEditItem.Url,
                    Title: currentEditItem.Title,
                    Description: currentEditItem.Description,
                    UserId: user.id,
                    WebsiteId: currentEditItem.WebsiteId,
                    CompanyName: currentEditItem.companyName,
                    PublisherName: currentEditItem.publisherName
                };
                await WebsiteApiService.Update(websiteData);
            } else if (editType === "App") {
                const appData = {
                    Name: currentEditItem.Name,
                    Url: currentEditItem.Url,
                    Title: currentEditItem.Title,
                    Description: currentEditItem.Description,
                    UserId: user.id,
                    AppId: currentEditItem.AppId,
                    Id: currentEditItem.Id,
                };
                await AppApiService.Update(appData);
            }

            toast.success("Edit Successful");
            setIsEditing(false);
            fetchData(); // Refresh data after editing
        } catch (error) {
            console.error("Error updating item:", error);
            toast.error("Edit Failed");
        }
    };


    const openDeleteModal = (item) => {
        debugger
        const activeData = activeTable === "Website" ? webData : appData;
    //   var selectedWebsite = activeData.find(x => x.WebsiteId == item.WebsiteId);
        setCurrentItem(item); // Store the current item for deletion
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        if (!currentItem) {
            toast.error("Invalid item selected!");
            return;
        }

        try {
            if (currentItem.status === "Website") {
                await WebsiteApiService.Delete(currentItem.WebsiteId);
            } else if (currentItem.status === "App") {
                await AppApiService.Delete(currentItem.Id);
            } else {
                throw new Error("Invalid item type");
            }
            toast.success("Item deleted successfully!");
            setIsDeleteModalOpen(false);
            fetchData(); // Refresh data after deletion
        } catch (error) {
            console.error("Error deleting item:", error);
            toast.error(error.message || "Failed to delete the item!");
        }
    };


    const handleCancelDelete = () => {
        setIsDeleteModalOpen(false);
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const activeData = activeTable === "Website" ? webData : appData;
        const filteredResults = activeData.filter((item) =>
            Object.values(item).some((val) =>
                val?.toString().toLowerCase().includes(value)
            )
        );
        activeTable === "Website" ? setWebFilteredData(filteredResults) : setAppFilteredData(filteredResults);
    };
    // Custom Styles
    const customStyles = {
        headRow: {
            style: {
                background: "linear-gradient(to right, #9333EA, #EC4899)",
            },
        },
        headCells: {
            style: {
                color: "#fff", // Equivalent to text-white
                fontWeight: "bold",
                fontSize: "14px",
            },
        },
    };

    const webColumns = webHeaders.map(({ label, icon, selector }) => {
        if (label === "Attachment") {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                cell: (row, index) => (
                    row.IsAttachmentAvailable && (<div className="flex items-center space-x-2">
                        <button
                            onClick={() => DownloadWebRejectionAttachment(row.WebsiteId)}
                            className="bg-green-500 px-3 py-1 text-white rounded flex-shrink-0"
                        >
                            Attachment
                        </button>
                    </div>)

                ),
                // grow: 1
            };
        }
        else if (label === "Actions") {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                cell: (row, index) => (
                    <div className="flex items-center space-x-2">

                        <button
                            onClick={() => openEditModal("Website", row)}
                            className="bg-blue-500 px-3 py-1 text-white rounded flex-shrink-0"
                        >
                            Edit
                        </button>
                        {admin && (
                            <button
                                onClick={() => openDeleteModal(row)}
                                className="bg-red-500 px-3 py-1 text-white rounded flex-shrink-0"
                            >
                                Delete
                            </button>
                        )}
                    </div>
                ),
                // grow: 1
            };
        }
        else if (label === "Status") {
            {
                return {
                    name: (
                        <div className="flex items-center">
                            {icon}
                            <span className="ml-2">{label}</span>
                        </div>
                    ),
                    cell: (row, index) => (admin ?
                        (<select
                            className={`border m-2 p-2 rounded-full ${row.ApprovalStatus == status.GettingReady ? "text-yellow-400 focus:ring-yellow-300" : row.ApprovalStatus == status.Approved ? "text-green-700 focus:ring-green-500" : "text-red-700 focus:ring-red-500"} bg-transparent focus:ring-2 focus:outline-none shadow-sm transition-all duration-300`}
                            value={row.ApprovalStatus}
                            onChange={(e) => changeWebsiteStatus(e, row.WebsiteId)}
                        >
                            <option className="text-yellow-400" value={status.GettingReady}>
                                Getting Ready
                            </option>
                            <option className="text-green-700" value={status.Approved}>
                                Approved
                            </option>
                            <option className="text-red-700" value={status.Disapproved}>
                                Disapproved
                            </option>
                        </select>
                        ) : row.ApprovalStatus === status.Approved ? (
                            <button
                                type="button"
                                className="text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-800"
                            >
                                Approved
                            </button>
                        ) : row.ApprovalStatus === status.GettingReady ? (
                            <button
                                type="button"
                                className="text-yellow-400 hover:text-white border border-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2 dark:border-yellow-300 dark:text-yellow-300 dark:hover:text-white dark:hover:bg-yellow-400 dark:focus:ring-yellow-900"
                            >
                                Getting Ready
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                            >
                                Disapproved
                            </button>
                        )),
                }
            }

        }
        else {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                selector: (row) => row[selector]?.toString() ?? "",
                sortable: true,
                // grow:0
            };
        }
    });

    const appColumns = appHeaders.map(({ label, icon, selector }) => {
        if (label === "Attachment") {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                cell: (row, index) => (
                    row.IsAttachmentAvailable && (<div className="flex items-center space-x-2">
                        <button
                            onClick={() => DownloadAppRejectionAttachment(row.Id)}
                            className="bg-green-500 px-3 py-1 text-white rounded flex-shrink-0"
                        >
                            Attachment
                        </button>
                    </div>)

                ),
                // grow: 1
            };
        }
        else if (label === "Actions") {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                cell: (row, index) => (
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => openEditModal("App", appData[index])}
                            className="bg-blue-500 px-3 py-1 text-white rounded flex-shrink-0"
                        >
                            Edit
                        </button>
                        {admin && (
                            <button
                                onClick={() => openDeleteModal(index)}
                                className="bg-red-500 px-3 py-1 text-white rounded flex-shrink-0"
                            >
                                Delete
                            </button>
                        )}
                    </div>
                ),
                // grow: 1
            };
        }
        else if (label === "Status") {
            {
                return {
                    name: (
                        <div className="flex items-center">
                            {icon}
                            <span className="ml-2">{label}</span>
                        </div>
                    ),
                    cell: (row, index) => (admin ?
                        (<select
                            className={`border m-2 p-2 rounded-full ${row.ApprovalStatus == status.GettingReady ? "text-yellow-400 focus:ring-yellow-300" : row.ApprovalStatus == status.Approved ? "text-green-700 focus:ring-green-500" : "text-red-700 focus:ring-red-500"} bg-transparent focus:ring-2 focus:outline-none shadow-sm transition-all duration-300`}
                            value={row.ApprovalStatus}
                            onChange={(e) => changeAppStatus(e, row.Id)}
                        >
                            <option className="text-yellow-400" value={status.GettingReady}>
                                Getting Ready
                            </option>
                            <option className="text-green-700" value={status.Approved}>
                                Approved
                            </option>
                            <option className="text-red-700" value={status.Disapproved}>
                                Disapproved
                            </option>
                        </select>
                        ) : row.ApprovalStatus === status.Approved ? (
                            <button
                                type="button"
                                className="text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-800"
                            >
                                Approved
                            </button>
                        ) : row.ApprovalStatus === status.GettingReady ? (
                            <button
                                type="button"
                                className="text-yellow-400 hover:text-white border border-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2 dark:border-yellow-300 dark:text-yellow-300 dark:hover:text-white dark:hover:bg-yellow-400 dark:focus:ring-yellow-900"
                            >
                                Getting Ready
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                            >
                                Disapproved
                            </button>
                        )),
                }
            }

        }
        else {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                selector: (row) => row[selector]?.toString() ?? "",
                sortable: true,
                // grow:0
            };
        }
    });

    return (
        <div className="overflow-x-auto p-5">
            <h1 className="text-2xl font-bold text-gray-800 mb-5">Web/Apps Details</h1>

            {/* Toggle Buttons */}
            <div className="flex justify-start mb-4">
                <button
                    onClick={() => setActiveTable("Website")}
                    className={`px-4 py-2 rounded-l-lg ${activeTable === "Web" ? "bg-blue-500 text-white" : "bg-gray-200"
                        }`}
                >
                    Website
                </button>
                <button
                    onClick={() => setActiveTable("App")}
                    className={`px-4 py-2 rounded-r-lg ${activeTable === "App" ? "bg-blue-500 text-white" : "bg-gray-200"
                        }`}
                >
                    App
                </button>
            </div>
            <div className="flex justify-end mb-4">
                <input
                    type="text"
                    className="border border-gray-300 px-4 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Search by Name"
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </div>
            {/* Web Table */}
            {activeTable === "Website" && (
                <DataTable
                    columns={webColumns}
                    data={webFilteredData}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    className="min-w-full bg-white border-collapse"
                    customStyles={customStyles}
                />
            )}
            {/* Rejection reason modal */}
            {isRejectionModalOpen && (
                <div className="z-20 fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                        <h3 className="text-md font-semibold text-gray-800 mb-4">Enter Rejection Reason</h3>
                        <textarea
                            className="w-full p-2 border rounded-lg text-gray-800"
                            rows="4"
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Enter reason for rejection..."
                        />
                        <h3 className="text-md font-semibold text-gray-800 mb-4">Rejection Attachment</h3>
                        <input
                            type="file"
                            onChange={(e) => setRejectionFile(e.target.files[0])}
                        />

                        <div className="flex justify-end mt-4 space-x-2">
                            <button
                                onClick={async () => { setRejectionFile(null); setRejectionReason(""); setIsRejectionModalOpen(false); await fetchData(); }}
                                className="px-4 py-2 bg-gray-400 text-white rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleRejectionStatus}
                                className="px-4 py-2 bg-red-500 text-white rounded"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* App Table */}
            {activeTable === "App" && (
                <DataTable
                    columns={appColumns}
                    data={appFilteredData}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    className="min-w-full bg-white border-collapse"
                    customStyles={customStyles}
                />
            )}

            {/* Edit Modal */}
            {/* Modal */}
            {isEditing && (
                <div className="modal fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                        <h2 className="text-xl font-bold mb-4">
                            Edit {editType === "Website" ? "Website" : "App"}
                        </h2>

                        {/* Edit Form for Website */}
                        {editType === "Website" && (
                            <form onSubmit={handleEditSubmit}>
                                <label className="block mb-2 font-semibold">Name</label>
                                <input
                                    type="text"
                                    value={currentEditItem?.Name || ""}
                                    onChange={(e) =>
                                        setCurrentEditItem({ ...currentEditItem, Name: e.target.value })
                                    }
                                    className="border rounded w-full px-3 py-2 mb-4"
                                />

                                <label className="block mb-2 font-semibold">URL</label>
                                <input
                                    type="text"
                                    value={currentEditItem?.Url || ""}
                                    onChange={(e) =>
                                        setCurrentEditItem({ ...currentEditItem, Url: e.target.value })
                                    }
                                    className="border rounded w-full px-3 py-2 mb-4"
                                />

                                <div className="flex actions">

                                    <button
                                        type="submit"
                                        className="mt-4 mx-1 bg-blue-500 text-white px-4 py-2 rounded"
                                    >
                                        Save
                                    </button>
                                    <button
                                        onClick={() => setIsEditing(false)}
                                        className="mt-4 mx-1 bg-red-500 text-white px-4 py-2 rounded"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        )}

                        {/* Edit Form for App */}
                        {editType === "App" && (
                            <form onSubmit={handleEditSubmit}>
                                <label className="block mb-2 font-semibold">App Id</label>
                                <input
                                    type="text"
                                    value={currentEditItem?.AppId || ""}
                                    onChange={(e) =>
                                        setCurrentEditItem({ ...currentEditItem, AppId: e.target.value })
                                    }
                                    className="border rounded w-full px-3 py-2 mb-4"
                                />

                                <label className="block mb-2 font-semibold">App Name</label>
                                <input
                                    type="text"
                                    value={currentEditItem?.Name || ""}
                                    onChange={(e) =>
                                        setCurrentEditItem({ ...currentEditItem, Name: e.target.value })
                                    }
                                    className="border rounded w-full px-3 py-2 mb-4"
                                />

                                <label className="block mb-2 font-semibold">App Url</label>
                                <input
                                    type="text"
                                    value={currentEditItem?.Url || ""}
                                    onChange={(e) =>
                                        setCurrentEditItem({ ...currentEditItem, Url: e.target.value })
                                    }
                                    className="border rounded w-full px-3 py-2 mb-4"
                                />
                                <div className="flex actions">
                                    <button
                                        type="submit"
                                        className="mt-4 mx-1 bg-blue-500 text-white px-4 py-2 rounded"
                                    >
                                        Save
                                    </button>
                                    <button
                                        onClick={() => setIsEditing(false)}
                                        className="mt-4 mx-1 bg-red-500 text-white px-4 py-2 rounded"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        )}

                    </div>
                </div>
            )}


            {/* Delete Confirmation Modal */}
            {isDeleteModalOpen && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-5 rounded shadow-lg w-1/3">
                        <h2 className="text-2xl font-bold mb-4">Confirm Deletion</h2>
                        <p className="mb-4">Are you sure you want to delete this item?</p>
                        <div className="flex justify-end">
                            <button
                                onClick={confirmDelete}
                                className="bg-red-500 text-white px-4 py-2 rounded mr-2"
                            >
                                Yes, Delete
                            </button>
                            <button
                                onClick={handleCancelDelete}
                                className="bg-gray-500 text-white px-4 py-2 rounded"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default WebsiteTable;
